import { FC } from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'
import { LevelRatingCheckList_ExamSurveyQuestionFragment } from 'generated/graphql'
import QUESTION_SUBJECT_MAP from '@app.feature/exam/gsat2024-2/constants/questionSubjectMap'
import ChoiceQuestionDesktop from './ChoiceQuestion.desktop'
import { InputAnswerItemDesktopProps } from './InputAnswerItem.desktop'
import InputQuestionDesktop from './InputQuestion.desktop'

gql`
  fragment LevelRatingCheckList_examSurveyQuestion on ExamSurveyQuestion {
    seq
    content
    id
    maxSelectCount
    isNumericAnswer
    isMultiSelectAvailable
    answer {
      nodes {
        ...ChoiceQuestion_examSurveyAnswer
      }
    }
  }
`

interface LevelRatingCheckListDesktopProps {
  questions: LevelRatingCheckList_ExamSurveyQuestionFragment[]
}

const LevelRatingCheckListDesktop: FC<LevelRatingCheckListDesktopProps> = ({
  questions,
}) => {
  return (
    <StyledWrapper>
      {questions.map((question, index) => {
        const answerList = question.answer.nodes
        const questionLabel = `${index + 1}. ${question.content}`
        const inputQuestionArray: InputAnswerItemDesktopProps[] =
          question.answer.nodes.map((answer) => {
            return {
              answer,
              questionId: question.id,
              questionSeq: question.seq,
              inputQuestionSubject: QUESTION_SUBJECT_MAP[answer.seq],
            }
          })

        return question.isNumericAnswer ? (
          <InputQuestionDesktop
            questioonLabel={questionLabel}
            answerList={inputQuestionArray}
            key={question.id}
          />
        ) : (
          <ChoiceQuestionDesktop
            questioonLabel={questionLabel}
            answerList={answerList}
            questionSeq={question.seq}
            questionId={question.id}
            key={question.id}
          />
        )
      })}
    </StyledWrapper>
  )
}

export default LevelRatingCheckListDesktop

const StyledWrapper = styled.div`
  padding: 48px;
  width: 820px;
  min-height: 300px;
  border-radius: 20px;
  border: solid 1px #e8e8e8e8;
  background-color: #fff;
`
